import { z } from 'zod';

import { MediaTypeEnum } from '../../enums';
import { levelEnumValidator, uuidValidator } from '../../validators';

export const MediaFilterQuerySchema = z.object({
  level: levelEnumValidator.optional(),
  tagId: uuidValidator.optional(),
  title: z.string().optional(),
  type: z.nativeEnum(MediaTypeEnum).optional(),
});

export type IMediaFilterQuery = z.infer<typeof MediaFilterQuerySchema>;
